__turbopack_context__.v({
  "customNext": "PreviewImagesSlider-module__pAkB3q__customNext",
  "customPrev": "PreviewImagesSlider-module__pAkB3q__customPrev",
});
